export default {
  props: {
    propReadOnly: {
      default: () => false,
      type: Boolean,
    },
  },
  methods: {
    /* Utils */
    deepCloneObj(obj) {
      // deep clones an object using JSON stringify (data loss might occur)
      if (Array.isArray(obj)) {
        return obj.map((item) => JSON.parse(JSON.stringify(item)));
      } else if (typeof obj == 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
    },
    async $_analysisMixin_calculateNewTimeFilters(filter_params, timeFilter) {
      const isDateLike = (val) =>
        (val instanceof Date && !isNaN(val)) ||
        (typeof val === 'string' && !isNaN(Date.parse(val)));

      const nonDatetimeOperands = filter_params.operands.filter(
        (op) => Array.isArray(op.values) && !op.values.some(isDateLike),
      );

      filter_params['operands'] = nonDatetimeOperands;

      if (timeFilter == 'All data') {
        // Remove datelike params
        // const isDateLike = val =>
        //   (val instanceof Date && !isNaN(val)) ||
        //   (typeof val === 'string' && !isNaN(Date.parse(val)));
        // const nonDatetimeOperands  = filter_params.operands.filter(op =>
        //   Array.isArray(op.values) && !op.values.some(isDateLike)
        // );
        // filter_params['operands'] = nonDatetimeOperands ;
      } else {
        if (timeFilter == 'This year') {
          const now = new Date();
          const startOfYear = new Date(now.getFullYear(), 0, 1);

          filter_params = this.getNowOperand(now, filter_params);
          let then_operand = this.getThenOperand(startOfYear);
          filter_params['operands'].push(then_operand);
        }

        if (timeFilter == 'Last year') {
          const now = new Date();
          const lastYear = now.getFullYear() - 1;

          const startOfYear = new Date(lastYear, 0, 1, 0, 0, 0); // Jan 1st, 00:00:00
          const endOfYear = new Date(lastYear, 11, 31, 23, 59, 59, 999); // Dec 31st, 23:59:59.999

          filter_params = this.getNowOperand(endOfYear, filter_params);
          let then_operand = this.getThenOperand(startOfYear);
          filter_params['operands'].push(then_operand);
        }

        if (timeFilter == 'This quarter') {
          const now = new Date();
          const currentMonth = now.getMonth(); // 0 = Jan, 11 = Dec
          const currentQuarter = Math.floor(currentMonth / 3); // 0 = Q1, 1 = Q2, etc.
          const year = now.getFullYear();

          // Start of this quarter
          const startOfQuarter = new Date(year, currentQuarter * 3, 1, 0, 0, 0, 0);

          filter_params = this.getNowOperand(now, filter_params);
          let then_operand = this.getThenOperand(startOfQuarter);
          filter_params['operands'].push(then_operand);
        }

        if (timeFilter == 'Last quarter') {
          const now = new Date();
          const currentMonth = now.getMonth(); // 0 = Jan, 11 = Dec
          const currentQuarter = Math.floor(currentMonth / 3);
          const lastQuarter = currentQuarter === 0 ? 3 : currentQuarter - 1;
          const year = currentQuarter === 0 ? now.getFullYear() - 1 : now.getFullYear();

          const startOfLastQuarter = new Date(year, lastQuarter * 3, 1, 0, 0, 0);
          const endOfLastQuarter = new Date(year, lastQuarter * 3 + 3, 0, 23, 59, 59, 999);

          filter_params = this.getNowOperand(endOfLastQuarter, filter_params);
          let then_operand = this.getThenOperand(startOfLastQuarter);
          filter_params['operands'].push(then_operand);
        }

        if (timeFilter == 'This month') {
          const now = new Date();

          // Start of this month: 1st at 00:00:00
          const startOfThisMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);

          filter_params = this.getNowOperand(now, filter_params);
          let then_operand = this.getThenOperand(startOfThisMonth);
          filter_params['operands'].push(then_operand);
        }

        if (timeFilter == 'Last month') {
          const now = new Date();
          const year = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
          const month = now.getMonth() === 0 ? 11 : now.getMonth() - 1;

          const startOfLastMonth = new Date(year, month, 1, 0, 0, 0, 0);
          const endOfLastMonth = new Date(year, month + 1, 0, 23, 59, 59, 999);

          filter_params = this.getNowOperand(endOfLastMonth, filter_params);
          let then_operand = this.getThenOperand(startOfLastMonth);
          filter_params['operands'].push(then_operand);
        }

        if (timeFilter == 'Last week') {
          const now = new Date();
          const dayOfWeek = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

          // Calculate how many days to subtract to get to last Monday
          const daysSinceMonday = ((dayOfWeek + 6) % 7) + 7;

          const startOfLastWeek = new Date(now);
          startOfLastWeek.setDate(now.getDate() - daysSinceMonday);
          startOfLastWeek.setHours(0, 0, 0, 0);

          const endOfLastWeek = new Date(startOfLastWeek);
          endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
          endOfLastWeek.setHours(23, 59, 59, 999);

          filter_params = this.getNowOperand(endOfLastWeek, filter_params);
          let then_operand = this.getThenOperand(startOfLastWeek);
          filter_params['operands'].push(then_operand);
        }

        if (timeFilter == 'Last seven days') {
          const now = new Date();
          const dayOfWeek = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

          // Calculate how many days to subtract to get to Monday
          const daysSinceMonday = (dayOfWeek + 6) % 7;

          const startOfWeek = new Date(now);
          startOfWeek.setDate(now.getDate() - daysSinceMonday);
          startOfWeek.setHours(0, 0, 0, 0);

          filter_params = this.getNowOperand(now, filter_params);
          let then_operand = this.getThenOperand(startOfWeek);
          filter_params['operands'].push(then_operand);
        }

        if (timeFilter == 'Yesterday') {
          const now = new Date();

          // Start of yesterday
          const startOfYesterday = new Date(now);
          startOfYesterday.setDate(now.getDate() - 1);
          startOfYesterday.setHours(0, 0, 0, 0);

          // End of yesterday
          const endOfYesterday = new Date(now);
          endOfYesterday.setDate(now.getDate() - 1);
          endOfYesterday.setHours(23, 59, 59, 999);

          filter_params = this.getNowOperand(endOfYesterday, filter_params);
          let then_operand = this.getThenOperand(startOfYesterday);
          filter_params['operands'].push(then_operand);
        }

        if (timeFilter == 'Today') {
          const now = new Date();

          // Start of today: 00:00:00.000
          const startOfToday = new Date(now);
          startOfToday.setHours(0, 0, 0, 0);

          filter_params = this.getNowOperand(now, filter_params);
          let then_operand = this.getThenOperand(startOfToday);
          filter_params['operands'].push(then_operand);
        }

        // TODO easily add individual months
        // const now = new Date();
        // const year = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();

        // const startOfLastJanuary = new Date(year, 0, 1, 0, 0, 0, 0); // Jan 1st, 00:00:00
        // const endOfLastJanuary = new Date(year, 1, 0, 23, 59, 59, 999); // Jan 31st, 23:59:59.999
      }
      if (!filter_params['operands'].length) {
        filter_params = {};
      }
      return filter_params;
    },
    getNowOperand(now, original_filter_params) {
      let filter_params = {};
      if (!original_filter_params || !Object.keys(original_filter_params).length) {
        // Start of filter
        filter_params = {
          global_combine_action: 'and',
          operands: [],
        };
      } else {
        filter_params = original_filter_params;
      }
      let question_id = this.dataset.created_on_column_id;
      let values = [];
      values.push(now);
      let now_operand = {
        client_question_id: question_id,
        operator: 'less_than',
        values: values,
      };
      filter_params.operands.push(now_operand);
      return filter_params;
    },
    getThenOperand(then) {
      // End of filter
      let values = [];
      values.push(then);
      let question_id = this.dataset.created_on_column_id;
      let then_operand = {
        client_question_id: question_id,
        operator: 'greater_than',
        values: values,
      };
      return then_operand;
    },
  },
};
